define('common/js/lib/Serum.Pubsub',['signals'], function(signals) {
  'use strict';

  var topics = {
    CONTENT_LOADED: new signals.Signal(), // published when Serum.Asset has loaded html and script assets

    CHANGE_IMAGES: new signals.Signal(), // published when the images needs to reload
    CHANGED_PROFILE: new signals.Signal(), // published when the profile changes (w500, etc)

    DID_SCROLL: new signals.Signal(), // published when the user scrolls (500ms throttle)
    DID_RESIZE: new signals.Signal(), // published when the screen resizes (500ms throttle)

    TIME_EVENT: new signals.Signal(), // published when the Serum.Time is updated (ie. from server)

    TRACK_EVENT: new signals.Signal(), // published when an inline event is to be tracked (eg. 404, gallery complete, etc)
    TRACK_PAGE: new signals.Signal(), // published when an inline page is loaded (ie. pushstate)
    TRACK_FWDNAV_IMPRESSION: new signals.Signal(), // published when a GA eCommerce impression should be registered
    TRACK_FWDNAV_CLICK: new signals.Signal(), // published when a GA eCommerce click should be registered
    TRACK_FWDNAV_DETAIL: new signals.Signal(), // published when a GA eCommerce detail should be registered
    TRACK_FWDNAV_STARTED: new signals.Signal(), // published when a GA eCommerce consumption start should be registered
    TRACK_FWDNAV_COMPLETED: new signals.Signal(), // published when a GA eCommerce consumption completed should be registered

    TRACK_EXPERIMENTS: new signals.Signal(), // published when AB experiments has loaded

    VIDEO_DID_START: new signals.Signal(), // published when a video starts
    VIDEO_DID_PREPARE: new signals.Signal(), // published when a Ludo video is prepared and metadata is ready
    VIDEO_DID_LOAD: new signals.Signal(), // published when a video has loaded
    VIDEO_DID_ERROR: new signals.Signal(), // published when a video did not load
    VIDEO_DID_STOP: new signals.Signal(), // published when a video has stopped/unloaded
    VIDEO_DID_CHANGE_STATE: new signals.Signal(), // published when a video has changed its state

    CONTENT_RELOAD: new signals.Signal(), // published when surrogate content is to be replaced

    REQUIRE_FAILED: new signals.Signal(), // published when requirejs fails

    PATH_STATE_CHANGE: new signals.Signal(),
    QUERY_STATE_CHANGE: new signals.Signal(),

    CONTENT_DID_FAIL: new signals.Signal(), // published when surrogate content fails to render

    CONTENT_INSERT: new signals.Signal()
  };

  // sample call: Pubsub.publish(Pubsub.topics.CONTENT_DID_FAIL, {});

  function getTopic(topic) {
    if (typeof topic === 'string') {
      var t = topics[topic];
      if (!t) {
        t = new signals.Signal();
        topics[topic] = t;
      }
      topic = t;
    }
    return topic;
  }

  function publish(topic, args) {
    getTopic(topic).dispatch(args || {});
  }

  function subscribe(topic, callback, defer) { // eslint-disable-line no-unused-vars
    getTopic(topic).add(callback);
  }

  function unsubscribe(topic, callback) {
    if (!callback) {
      getTopic(topic).removeAll();
    } else {
      getTopic(topic).remove(callback);
    }
  }

  function once(topic, callback) {
    getTopic(topic).addOnce(callback);
  }

  return {
    publish: publish,
    subscribe: subscribe,
    unsubscribe: unsubscribe,
    once: once,
    topics: topics,
    getTopic: getTopic
  };

});
